import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { URL_API } from "../config/config";
import { Marca } from '../models/marcas.model';

@Injectable({
  providedIn: 'root'
})
export class MarcasService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })
  };

constructor(private http: HttpClient) { }

  get_listar() {
    const url = URL_API + '/marcas/get_listar';
    return this.http.get(url);
  }

  get_buscar(pagina: string, limit: string, buscar: string) {
    const url = URL_API + '/marcas/get_buscar/' + pagina + '/' + limit + '/' + buscar;
    return this.http.get(url);
  }

  create(model: any) {
    const url = URL_API + '/marcas/nuevo';
    return this.http.post(url, model, this.httpOptions);
  }

  getbyid(id: string) {
    const url = URL_API + '/marcas/get_byid/' + id;
    return this.http.get(url);
  }

  update(id: string, model: Marca) {
    const url = URL_API + '/marcas/update/' + id;
    return this.http.put(url, model, this.httpOptions);
  }

  getdelete (id: string)  {
    const url = URL_API + '/marcas/delete/' + id;
    return this.http.delete(url, this.httpOptions);
  }
}
